import loadable from '@loadable/component';

export const FullscreenGalleryContainer = loadable(() => import('./FullscreenGalleryContainer'), {
  resolveComponent: component => component.FullscreenGalleryContainer,
});
